<ng-container [ngSwitch]="mode">
  <!-- Company mode (In-Depth) -->
  <app-in-depth-dashboard
    *ngSwitchCase="'company'"
    [quickBuild]="quickBuild"
    [dateRangeStrings]="dateRangeStrings"
    [reportTarget]="reportTarget"
    [chartConfigs]="chartConfigs"
    (configChange)="onChartConfigChange($event.chartId, $event.config)">
  </app-in-depth-dashboard>

  <!-- Battle mode (Head-to-Head) -->
  <app-head-to-head-dashboard
    *ngSwitchCase="'battle'"
    [companyBattleQBs]="companyBattleQBs"
    [dateRangeStrings]="dateRangeStrings"
    [reportTarget]="reportTarget"
    [chartConfigs]="chartConfigs"
    (configChange)="onChartConfigChange($event.chartId, $event.config)">
  </app-head-to-head-dashboard>

  <!-- Benchmark mode -->
  <app-benchmark-dashboard
    *ngSwitchCase="'benchmark'"
    [benchmarkQuickBuilds]="benchmarkCompanyQBs"
    [dateFrom]="dateRangeStrings[0]"
    [dateTo]="dateRangeStrings[1]"
    [reportTarget]="reportTarget"
    [selectedJobFunctions]="selectedJobFunctions"
    [selectedLevels]="selectedJobLevels"
    [selectedRoles]="selectedRole ? [selectedRole.name] : undefined">
  </app-benchmark-dashboard>
</ng-container>
